import { DatePivotParams } from "../../entities/date_pivot_params";

export const defaultChartViewerConfig = (viewParams: DatePivotParams) => {
  const dateHierarchy = viewParams?.dateHierarchy || "week";
  const selectedMeasure = viewParams?.measure || "quantity";
  const segments = viewParams?.segments || [];

  // If there are segments, create multiple series for each segment combination
  if (segments.length > 0) {
    return {
      chartType: "bar" as const,
      xAxisField: dateHierarchy,
      yAxisFields: [selectedMeasure],
      datasetLabels: {
        [selectedMeasure]: selectedMeasure === "quantity" ? "Quantity" : "Cost",
      },
      segments: segments,
    };
  }

  // No segments - single series
  return {
    chartType: "bar" as const,
    xAxisField: dateHierarchy,
    yAxisFields: [selectedMeasure],
    datasetLabels: {
      [selectedMeasure]: selectedMeasure === "quantity" ? "Quantity" : "Cost",
    },
  };
};
